export default __webpack_public_path__ + "static/profile-avatar-1-4fcdd22bc1ad4eb5ba840da9aa886485.png";